import { aboutPage } from "./aboutPage";
import { accountPage } from "./accountPage";
import { bagPage } from "./bagPage";
import { blogPost } from "./blogPost";
import { categoryImages } from "./categoryImages";
import { clientCarePage } from "./clientCarePage";
import { contactPage } from "./contactPage";

import { customRequestPage } from "./customRequestPage";
import { emailLog } from "./emailLog";
import { emailTemplate } from "./emailTemplate";
import { eventsPage } from "./eventsPage";
import { favoritesPage } from "./favoritesPage";
import { homePage } from "./homePage";
import { inStorePage } from "./inStorePage";
import { itemBullets } from "./itemBullets";
import { jewelryCarePage } from "./jewelryCarePage";
import { mailingGroup } from "./mailingGroup";
import { returnsPage } from "./returnsPage";
import { shopPage } from "./shopPage";
import { siteSettings } from "./siteSettings";

export const schemaTypes = [siteSettings, homePage, aboutPage, shopPage, contactPage, itemBullets, clientCarePage, returnsPage, jewelryCarePage, categoryImages, customRequestPage, eventsPage, inStorePage, bagPage, favoritesPage, accountPage, emailTemplate, mailingGroup, emailLog, blogPost];
